import React from 'react'
import '../styles/ColorBlindness.css'
import ColorPicker from './ColorPicker'
import ImageSelector from './ImageSelector'
import { NavLink } from 'react-router-dom'
import { Routes, Route } from 'react-router-dom'

const ColorBlindness = ({setSimulatedColor, blindType, setBlindType, color, setColor}) => {

  return (
    <div className='color-blindness'>
      <section>
        <nav className='color-blindness-nav'>
            <ul>
              <NavLink to='/' className={({isActive}) => `navlink link ${isActive ? 'active' : ''}`}>Color Picker</NavLink>
              <NavLink to='/image-selector' className={({isActive}) => `navlink link ${isActive ? 'active' : ''}`}>Image Selector</NavLink>
            </ul>
        </nav>
        <Routes>
          <Route path='/' element={<ColorPicker
            color={color}
            setColor={setColor}
            setSimulatedColor={setSimulatedColor}
            blindType={blindType}
            setBlindType={setBlindType}
          />}/>
          <Route path='/image-selector' element={<ImageSelector/>}/>
        </Routes>
        
      </section>
    </div>
  )
}

export default ColorBlindness